import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import ResponsiveAppBar from "./components/AppBar";
import MainComponent from "../src/components/Main/Main";
import AboutUs from "../src/components/AboutUs/AboutUs";
import PartnerWithUs from "../src/components/PartnerWithUs/PartnerWithUs";
import Events from "../src/components/Events/Events";
import Gallery from "../src/components/Gallery/Gallery";
import BookNow from "../src/components/BookNow/BookNow";
import BlockSlot from "../src/components/BlockSlot/BlockSlot";
import MarkDateOffHoliday from "../src/components/MarkDateOffHoliday/MarkDateOffHoliday";
import BookingRecords from "../src/components/BookingRecords/BookingRecords";
import ContactUs from "./components/ContactUs/ContactUs";
import LocationLanding from "./components/LocationLanding/LocationLanding";
import PromptHandler from "./components/Prompts/PromptHandler";
import AdminPortal from "./components/AdminPortal/AdminPortal";
import MyAccount from "./components/MyAccount/MyAccount";
import Snackbar from "./components/shared/UI/Snackbar/Snackbar";
import RefundPolicy from "./components/OtherLinks/RefundPolicy";
import PrivacyPolicy from "./components/OtherLinks/PrivacyPolicy";
import TermsAndConditions from "./components/OtherLinks/TermsAndConditions";
import ValidateLocation from "./components/RouteGuards/ValidateLocation";
import ErrorPage from "./components/Error/ErrorPage";

import { loggedIn } from "./helpers/sessionStorageHelper";
import { logInUser } from "./dux/login";
import { shouldShowPrompt } from "./dux/prompt";

function App() {
  const dispatch = useDispatch();
  const showPrompt = useSelector(shouldShowPrompt);

  // Read from localStorage on first render
  const [userLocation] = useState(
    () => localStorage.getItem("selectedLocation") || null
  );

  // Login check after mount
  useEffect(() => {
    if (loggedIn()) {
      dispatch(logInUser());
    }
  }, [dispatch]);

  return (
    <div className="main-container">
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {showPrompt && <PromptHandler />}
        <Snackbar />
        <ResponsiveAppBar />

        <Routes>
          <Route path="/" element={<MainComponent />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/partner-with-us" element={<PartnerWithUs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/my-account/:tab" element={<MyAccount />} />

          {/* Routes using location */}
          <Route
            path="/book"
            element={
              userLocation ? (
                <Navigate to={`/book/${userLocation}`} />
              ) : (
                <ErrorPage />
              )
            }
          />

          {/* Location landing */}
          <Route
            path="/location/:location"
            element={
              <ValidateLocation>
                <LocationLanding />
              </ValidateLocation>
            }
          />

          {/* Actual location booking */}
          <Route
            path="/book/:location"
            element={
              <ValidateLocation>
                <BookNow />
              </ValidateLocation>
            }
          />

          {/* Admin/management pages */}
          <Route path="/block-slots" element={<BlockSlot />} />
          <Route
            path="/mark-date-off-or-holiday"
            element={<MarkDateOffHoliday />}
          />
          <Route path="/booking-records" element={<BookingRecords />} />
          <Route path="/admin-portal/:tab" element={<AdminPortal />} />

          {/* Errors */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
